<template>
	<div class="tips_wrap">
		<div class="tips_body">
			<div class="tips_ignore" @click="ignore">不再提示</div>
			<div class="tips_title">远程开机指引</div>
			<div class="tips_desc_wrap">
				<div class="tips_desc_icon"></div>
				<div class="tips_desc">
					<div class="tips_desc_title">确认电脑是否支持网络唤醒</div>
					<div class="tips_desc_content">
						重启电脑设备进入BIOS的电源管理菜单查看菜单是否有Remote
						Wake Up或Wake on LAN等类似选项，否则不支持远程开机。
					</div>
					<div class="tips_desc_content2" v-if="false">
						<span>如需帮助，可查看</span
						><span class="help">帮助文档</span>
					</div>
				</div>
			</div>
			<div class="tips_hr"></div>
			<div class="tips_btns">
				<div class="tips_btn tips_btn_close" @click="close">关闭</div>
				<div class="tips_btn tips_btn_wakeup" @click="wakeup">开机</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		ignore: function () {
			this.$emit("ignore");
		},
		close: function () {
			this.$emit("close");
		},
		wakeup: function () {
			this.$emit("wakeup");
		},
	},
};
</script>

<style lang="less" scoped>
.tips_wrap {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;
	.tips_body {
		width: 470px;
		height: 310px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -235px;
		margin-top: -170px;
		background-color: #ffffff;
		border-radius: 5px;
		text-align: center;
		.tips_ignore {
			right: 15px;
			top: 15px;
			position: absolute;
			cursor: pointer;
			color: #999999;
			font-size: 12px;
			height: 18px;
			line-height: 18px;
			border-bottom: 1px solid #999999;
		}
		.tips_ignore:hover {
			opacity: 0.9;
			cursor: pointer;
		}
		.tips_title {
			margin-top: 50px;
			color: #1a1a1a;
			font-size: 17px;
			font-weight: bolder;
			margin-bottom: 10px;
		}
		.tips_desc_wrap {
			text-align: center;
			margin-top: 30px;
			.tips_desc_icon {
				width: 157px;
				height: 125px;
				display: inline-block;
				vertical-align: top;
				background-image: url(../assets/home/node/wake_up_tips.png);
				background-size: 100% 100%;
			}
			.tips_desc {
				display: inline-block;
				vertical-align: top;
				width: 235px;
				text-align: left;
				margin-left: 15px;

				.tips_desc_title {
					color: #1a1a1a;
					font-size: 14px;
				}
				.tips_desc_content {
					color: #666666;
					font-size: 12px;
					margin-top: 15px;
					line-height: 18px;
				}
				.tips_desc_content2 {
					color: #666666;
					font-size: 12px;
					margin-top: 40px;
					.help {
						color: #1f5de3;
						text-decoration: underline;
					}
					.help:hover {
						opacity: 0.9;
						cursor: pointer;
					}
				}
			}
		}
		.tips_hr {
			width: 100%;
			height: 1px;
			margin-top: 10px;
			background-color: #e5e5e5;
		}
		.tips_btns {
			text-align: right;
			margin-top: 10px;
			.tips_btn {
				background-color: #215fe4;
				width: 115px;
				height: 40px;
				line-height: 40px;
				border-radius: 20px;
				margin: 0 auto;

				text-align: center;
				color: #f5f5f5;
				font-size: 14px;
				display: inline-block;
				vertical-align: top;
				margin-right: 14px;
				font-weight: bolder;
			}
			.tips_btn:hover {
				opacity: 0.9;
				cursor: pointer;
			}
			.tips_btn_close {
				background-color: #e5e5e5;
				color: #999999;
			}
		}
	}
}
</style>